
export default `
    query getGoogleSearchConsoleProperties ($authId: String!){
        getGoogleSearchConsoleProperties(authId: $authId) {
            urlPrefix {
              siteUrl
              permissionLevel
            }
            domain {
              siteUrl
              permissionLevel
            }
        }
    }
`;